export const UPDATE_CONVERSATION_BEGIN   = 'UPDATE_CONVERSATION_BEGIN'
export const UPDATE_CONVERSATION_SUCCESS = 'UPDATE_CONVERSATION_SUCCESS'
export const UPDATE_CONVERSATION_FAILED  = 'UPDATE_CONVERSATION_FAILED'

const updateConversationBegin   = (payload) => ({ type: UPDATE_CONVERSATION_BEGIN, payload })
const updateConversationSuccess = (payload) => ({ type: UPDATE_CONVERSATION_SUCCESS, payload })
const updateConversationFailed  = (payload) => ({ type: UPDATE_CONVERSATION_FAILED, payload })

export const updateConversation = (attrs) => {
  return (dispatch, getState) => {
    const { currentConversation } = getState()
    dispatch(updateConversationBegin({ attrs }))

    return $.ajax(`/api/staff/v1/conversations/${currentConversation.id}.json`, {
      method: 'PATCH',
      data: { conversation: attrs }
    })
      .then((response) => {
        dispatch(updateConversationSuccess(response))
        return response
      })
      .fail((xhr) => {
        dispatch(updateConversationFailed({ error: xhr?.responseJSON || true }))
        throw xhr
      })
  }
}
